import { defineMessage } from '../../services/localization';

export const messages = {
    dayShortnameSunday: defineMessage('su'),
    dayShortnameMonday: defineMessage('mo'),
    dayShortnameTuesday: defineMessage('tu'),
    dayShortnameWednesday: defineMessage('we'),
    dayShortnameThursday: defineMessage('th'),
    dayShortnameFriday: defineMessage('fr'),
    dayShortnameSaturday: defineMessage('sa'),
};
